/**
 * FilterButton component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled filter button.
 */
const FilterButton = styled.button<Props>`
  background: ${(props) => (props.fill ? Colors['light'] : 'none')};
  border: 2px solid ${Colors['light']};
  border-radius: ${25 * Screen.widthRatio}px;
  color: ${(props) => (props.fill ? Colors['dark'] : Colors['light'])};
  cursor: pointer;
  font-family: ${Fonts['regular']};
  font-size: ${24 * Screen.widthRatio}px;
  margin-right: ${8 * Screen.widthRatio}px;
  opacity: ${(props) => (props.focused ? '1' : '0.5')};
  padding: ${Screen.widthRatio * 12}px ${Screen.widthRatio * 20}px;
  &:hover {
    opacity: 1;
  }
`;

export default FilterButton;
